module.exports = __webpack_public_path__ + "aa33e03e16ab155ff142e425a1203273.png";